export const statistics = [
  {
    tittle: "$ROMI",
    list1: [
      ["Price", "$0.00"],
      ["Wallet", "... $ROMI ($...)"],
      ["Staked", "... $ROMI ($...)"],
    ],
    list2: [
      ["APR", "...%"],
      ["Rewards", "$..."],
      ["Multiplier Points APR", "100.00%"],
      ["Boost Percentage", "...%"],
    ],
    list3: [
      ["Total Staked", "0 $ROMI ($...)"],
      ["Total Supply", "10,000 $ROMI ($10)"],
    ],
    btn: "Buy $ROMI",
  },
  {
    tittle: "$ZLP (Ethereum)",
    list1: [
      ["Price", "$0.00"],
      ["Wallet", "... $ZLP ($...)"],
      ["Staked", "... $ZLP ($...)"],
    ],
    list2: [
      ["APR", "...%"],
      ["Rewards", "$..."],
    ],
    list3: [
      ["Total Staked", "0 $ZLP ($...)"],
      ["Total Supply", "10,000 $ZLP ($10)"],
    ],
    btn: "Buy $ZLP",
  },
  {
    tittle: "Escrowed $ROMI",
    list1: [
      ["Price", "$0.00"],
      ["Wallet", "... $ZLP ($...)"],
      ["Staked", "... $ZLP ($...)"],
    ],
    list2: [
      ["APR", "...%"],
      ["Multiplier Points APR", "$..."],
    ],
    list3: [
      ["Total Staked", "0 $ZLP ($...)"],
      ["Total Supply", "10,000 $ZLP ($10)"],
    ],
    btn: "Connect Wallet",
  },
  {
    tittle: "Total Rewards",
    list1: [
      ["ETH (WETH)", "... ($...)"],
      ["$ROMI", "... ($...)"],
      ["Escrowed $ROMI", "... ($...)"],
      ["Multiplier Points", "..."],
      ["Staked Multiplier Points", "..."],
      ["Total", "$..."],
    ],
    btn: "Connect Wallet",
  },
];

export const statistics2 = [
  {
    tittle: "$ROMI Vault",
    list1: [
      ["Staked Tokens", "..."],
      ["Reserved for Vesting", "0.00 / ..."],
      ["Vesting Status", "0.0000 / 0.0000"],
      ["Claimable", "0.0000 $ROMI"],
      ["Staked Multiplier Points", "..."],
      ["Total", "$..."],
    ],
    btn: "Connect Wallet",
  },
  {
    tittle: "$ZLP Vault",
    list1: [
      ["Staked Tokens", "..."],
      ["Reserved for Vesting", "0.00 / ..."],
      ["Vesting Status", "0.0000 / 0.0000"],
      ["Claimable", "0.0000 $ROMI"],
      ["Staked Multiplier Points", "..."],
      ["Total", "$..."],
    ],
    btn: "Connect Wallet",
  },
];
